import { FC } from 'react';
import AntUpload from 'antd/lib/upload';

import { UploadProps } from './types';

import styled from 'styled-components';

import { colors } from '@10d/tend-ui-tokens/samolet';

const Upload = styled<FC<UploadProps>>(AntUpload)`
  a {
    color: ${colors.blue600};
  }

  .ant-upload.ant-upload-select-picture-card,
  .ant-upload-list-picture-card .ant-upload-list-item,
  .ant-upload-list-picture-card-container {
    border-radius: 4px;
  }

  .ant-upload-list-item-card-actions-btn {
    display: inline-block;
    vertical-align: middle;
  }

  .ant-upload-list-item .anticon-close {
    position: absolute !important;
  }

  .ant-upload-disabled {
    pointer-events: none;

    button {
      background: #eaedf5;
      color: ${colors.gray400};
      border-color: #bdc5db;
    }
  }

  .ant-upload-list-item-card-actions {
    & svg {
      color: ${colors.red500};
    }
  }
`;

Upload.defaultProps = {
  showUploadList: {
    showRemoveIcon: true,
  },
};

export default Upload;
